import GetEnvironment from "../environments"

const SETTINGS_API = GetEnvironment().quadriSettingsApiUrl
const CACHE_EXPIRATION_MS = 5 * 60 * 1000 // 5 minutes
export const SETTINGS_CACHE: Record<string, { value: any; timestamp: number }> = {} // Cache to store connect URL

const fetchData = async (url: string, accessToken: string) => {
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      }
    })

    if (!response.ok) throw new Error(`Error ${response.status}: ${response.statusText}`)

    return await response.json()
  } catch (error) {
    console.error(`Fetch failed: ${url}`, error)
    return null
  }
}

export const getSettings = async (accessToken: string, projectLocation: string): Promise<any | null> => {
  const cached = SETTINGS_CACHE[projectLocation]
  const now = Date.now()

  // Check if cache exists and is not expired
  if (cached && now - cached.timestamp < CACHE_EXPIRATION_MS) {
    return cached.value
  }

  const data = await fetchData(`${SETTINGS_API}settings/${projectLocation}/all`, accessToken)
  if (data) {
    SETTINGS_CACHE[projectLocation] = { value: data, timestamp: now }
  } else {
    console.warn(`Failed to retrieve Connect URL for ${projectLocation}`)
  }
  return data
}

export const getRegions = async (accessToken: string): Promise<any | null> => {
  const cached = SETTINGS_CACHE["regions"]
  const now = Date.now()

  // Check if cache exists and is not expired
  if (cached && now - cached.timestamp < CACHE_EXPIRATION_MS) {
    return cached.value
  }

  const data = await fetchData(`${SETTINGS_API}regions`, accessToken)
  if (data) {
    SETTINGS_CACHE["regions"] = { value: data, timestamp: now }
  } else {
    console.warn(`Failed to fetch regions from settings API`)
  }
  return data
}
